var _circle, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8795,
    cy: 26,
    r: 26,
    fill: "#DBCDC7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0065,
    cy: 26.003,
    rx: 14.7302,
    ry: 14.8545,
    fill: "#FFF3F1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4509,
    cy: 29.0757,
    rx: 1.01587,
    ry: 1.53667,
    fill: "#262626"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5779,
    cy: 29.0757,
    rx: 1.01587,
    ry: 1.53667,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5462 32.6621H25.2287C25.2287 33.6866 25.9906 34.4549 27.5144 34.4549C28.9511 34.4549 29.4615 33.3451 29.5462 32.6621Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2313 11.1484C16.0001 11.3725 12.0224 20.6192 12.0224 25.7415L22.7425 24.9785L23.1302 20.2368H24.6807L25.0683 24.5834H29.3323L29.72 20.2368H31.2705L31.6582 24.5834H41.7367C41.2288 19.8561 37.9272 10.8923 26.2313 11.1484Z",
    fill: "#736B67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2922 19.5549C12.6827 20.9665 12.361 23.2016 12.2764 24.1427C17.8637 24.1427 30.3081 24.3936 41.7367 24.1376C41.7367 22.4437 41.0594 20.3511 40.7208 19.5276C29.0383 19.2716 18.6256 19.2715 13.2922 19.5549Z",
    fill: "#95ACF6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile10);
export default __webpack_public_path__ + "static/media/img_profile_10.d42c12ca32760154ebb80621687ea54d.svg";
export { ForwardRef as ReactComponent };